// /components/LanguageSwitcherMobile.js
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const LanguageSwitcherMobile = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Récupère la langue actuelle à partir de l'URL
  const currentLang = location.pathname.split("/")[1] || "fr";

  // Change la langue tout en gardant le reste de l'URL inchangé
  const toggleLanguage = () => {
    const newLang = currentLang === "fr" ? "en" : "fr";
    const newPath = location.pathname.replace(/^\/(fr|en)/, `/${newLang}`);
    navigate(newPath);
  };

  return (
    <button
      onClick={toggleLanguage}
      className="text-dark hover:text-primary"
    >
      {currentLang === "fr" ? "English" : "Français"}
    </button>
  );
};

export default LanguageSwitcherMobile;
